import { ESignupStages, IAcquirer, ILead, ISelfsignupState, IUserData, IVenueData } from "../types";

export const SET_TITLE = "SET_TITLE";

export function setTitle(title: string) {
    return {
        type: SET_TITLE,
        payload: title
    }
}

export const SET_STAGE = "SET_STAGE";

export function setStage(stage: ESignupStages) {
    return {
        type: SET_STAGE,
        payload: stage
    }
}

export const SET_USER_DETAILS = "SET_USER_DETAILS";

export function setUserDetails(userObject: IUserData) {
    return {
        type: SET_USER_DETAILS,
        payload: userObject
    }
}

export const GO_BACK = "GO_BACK";

export function goBack() {
    return {
        type: GO_BACK
    }
}

export const SET_VENUE_DATA = "SET_VENUE_DATA";

export function setVenueData(venueData: IVenueData) {
    return {
        type: SET_VENUE_DATA,
        payload: venueData
    }
}

export const SET_SUBSCRIPTION = "SET_SUBSCRIPTION";

export function setSubscription(id: string | null) {
    return {
        type: SET_SUBSCRIPTION,
        payload: id
    }
}

export const SET_LEAD_DATA = "SET_LEAD_DATA";

export function setLeadData(lead: Partial<ILead>) {
    return {
        type: SET_LEAD_DATA,
        payload: lead
    }
}

export const SET_LEAD_ID = "SET_LEAD_ID";

export function setLeadId(id: string) {
    return {
        type: SET_LEAD_ID,
        payload: id
    }
}

export const SET_SNAPSHOT = "SET_SNAPSHOT";

export function setSnapshot(state: ISelfsignupState) {
    return {
        type: SET_SNAPSHOT,
        payload: state
    }
}

export const SET_SALES_REF = "SET_SALES_REF";

export function setSalesRef(salesRef: string | null) {
    return {
        type: SET_SALES_REF,
        payload: salesRef
    }
}


export const SET_ACQUIRER_DATA = "SET_ACQUIRER_DATA";

export function setAcquirerData(data: IAcquirer) {
    return {
        type: SET_ACQUIRER_DATA,
        payload: data
    }
}

export const SET_HUBSPOT_ID = "SET_HUBSPOT_ID";

export function setHubSpotId(id: string) {
    return {
        type: SET_HUBSPOT_ID,
        payload: id
    }
}

export const SET_RESELLER = "SET_RESELLER";

export function setReseller(reseller: string) {
    return {
        type: SET_RESELLER,
        payload: reseller
    }
}